<div class="bg-gradient-to-r from-blue-400 via-blue-500 to-purple-600 text-white rounded-md mx-6 mt-4 shadow-lg overflow-hidden transition-all duration-500 px-2">
  <div class="flex justify-between items-center p-4">
        <div>
        <h2 class="text-2xl font-bold">{{ getSelectedDepartmentName() }} Overview</h2>
        <div class="flex items-center space-x-4 mt-1 text-sm">
            <!-- <span class="flex items-center space-x-1">
                <i class="far fa-calendar-alt"></i>
                <span>{{ getSelectedDepartmentName() }}</span>
                </span> -->
            <span class="flex items-center space-x-1">
                <i class="far fa-calendar-alt"></i>
                <span>{{ currentDate }}</span>
            </span>
            <span class="flex items-center space-x-1">
                <i class="far fa-clock"></i>
                <span>{{ currentTime }}</span>
            </span>
        </div>
        </div>

        <div class="flex items-center gap-6">
        <div class="text-right">
            <p class="font-bold">Live Dashboard</p>
            <p class="text-xs">Auto-refresh every 60 minutes</p>
        </div>

        <button 
            class="p-2 rounded-full bg-white/20 hover:bg-white/30 transition"
            (click)="showFilters = !showFilters"
            >
            <svg xmlns="http://www.w3.org/2000/svg" 
                fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" 
                class="w-6 h-6 text-white">
            <path stroke-linecap="round" stroke-linejoin="round" 
                    d="M3 4h18M6 12h12M10 20h4"/>
            </svg>
        </button>
        </div>
    </div>
    <div *ngIf="showFilters" class="px-4 pb-4">
    <div class="flex flex-wrap justify-center items-center gap-4">
      <select id="department" [ngModel]="departmentId()" 
              class="px-3 py-2 rounded-md bg-white/10 border border-white/20 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40"
             (ngModelChange)="onDepartmentChange($event)">
        <option value="null" hidden disabled selected>Choose a Department</option>
        @for (dept of $$departmentDTO(); track dept.departmentId) {
          <option [value]="dept.departmentId">{{ dept.departmentName | titlecase }}</option>
        }
      </select>
      <input 
        type="date" 
        class="px-3 py-2 rounded-md bg-white/10 border border-white/20 text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white/40"
        [value]="selectedDate()"
        (change)="onDateChange($event)">
    </div>
  </div>
</div>
<div class="px-4 mt-2">
    <div class="grid grid-cols-1 grid-cols-5 gap-4 md:gap-4 px-2 pt-2">
        <div class="bg-white rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
            <div class="flex justify-between w-full">
                <p class="text-4xl font-bold text-black">{{ totalJobs | number }}</p>
            </div>
            <p class="text-sm text-blue font-semibold">Total Job Count</p>
        </div>

        <div class="bg-gradient-to-br from-green-200 to-green-400 rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
            <div class="flex justify-between w-full">
                <p class="text-4xl font-bold text-black">{{ completedJobs | number }}</p>
            </div>
            <p class="text-sm text-blue font-semibold">Totally Completed Jobs</p>
            <div class="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div class="bg-green-500 h-2 rounded-full transition-all duration-500" 
                    [style.width.%]="completePercentage"></div>
                </div>
            <p class="text-base font-bold text-green-500 mt-1">
                {{ completePercentage }}%
            </p>
        </div>

        <div class="bg-gradient-to-br from-blue-200 to-blue-400 rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
            <div class="flex justify-between w-full">
                <p class="text-4xl font-bold text-black">{{ inProgressJobs | number }}</p>
            </div>
            <p class="text-sm font-semibold">In Progress Jobs</p>
            <div class="w-full bg-gray-300 rounded-full h-2 mt-2">
                <div class="bg-blue-500 h-2 rounded-full transition-all duration-500" 
                    [style.width.%]="progressPercentage"></div>
                </div>
            <p class="text-base font-bold text-blue-800 mt-1">
                {{ progressPercentage }}%
            </p>
        </div>

        <div class="bg-white text-gray-900 rounded-lg shadow-lg w-full flex flex-col items-start p-4 h-32">
            <div class="flex justify-between w-full">
                <p class="text-4xl font-bold text-black">{{ onHoldJobs | number }}</p>
            </div>
            <p class="text-sm text-gray-900 font-semibold">Total Hold Jobs</p>
        </div>
        <div class="bg-white text-gray-900 rounded-lg shadow-lg w-full flex flex-col items-start p-4">
            <div class="flex justify-between w-full">
                <p class="text-4xl font-bold">{{ dispatchedJobs | number }}</p>
            </div>
            <p class="text-sm font-semibold">Total Dispatched Jobs</p>
        </div>
    </div>
</div>


<div class="px-4">
    <div class="grid grid-cols-1 sm:grid-cols-1 xl:grid-cols-2">
        <div class="bg-white rounded-lg mx-2 mt-4 pt-4">
            <span class="font-bold text-lg ml-6">Scheduled Deliveries in the Next 48 Hours</span>
            <div #todayTable class="overflow-y-auto h-64 mt-4 no-scrollbar">
                <table class="table table-fixed w-full">
                    <!-- <thead class="text-sm text-gray-800 bg-gray-100">
                    <tr>
                        <th class="px-4 py-3 text-center">Job No</th>
                        <th class="px-4 py-3 text-center">Job Name</th>
                        <th class="px-4 py-3 text-center">Customer</th>
                        <th class="px-4 py-3 text-center">Status</th>
                        <th class="px-4 py-3 text-center">Dispatched</th>
                    </tr>
                    </thead> -->
                    <tbody>
                        @for (jobs of $$todayOrTomorrowJobs(); track jobs) {
                            <tr class="border-y sm:text-xs text-gray-900 text-center lg:text-[12px] justify-center" [ngClass]="{'bg-blue-100': jobs.dispatchQuantity > 0}">
                                <td class="px-2 py-2 break-words whitespace-normal">{{ jobs.jobNo }}</td>
                                <td class="pr-2 px-4 py-2 break-words whitespace-normal text-ellipsis text-left">{{ jobs.jobDescription }}</td>
                                <td class="py-2 px-4 break-words whitespace-normal uppercase text-ellipsis text-left">{{ jobs.customer || '-' }}</td>
                                <td class="py-2">
                                    <app-status-badge [jobStatus]="jobs.jobStatus"></app-status-badge>
                                </td>
                                
                                <td class="px-4 py-2 break-words whitespace-normal flex flex-col text-sm">
                                    <span class="font-bold">{{ jobs.dispatchQuantity }}</span>
                                    <span class="text-gray-400 text-xs">( {{ jobs.jobQuantity - jobs.dispatchQuantity }} )</span>
                                </td>
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="12" class="px-6 py-10">
                                    <div class="flex flex-col items-center justify-center text-center">
                                        <p class="text-xl font-semibold text-gray-700 mb-2">No Jobs Found</p>
                                        <p class="text-gray-500">We couldn't find any jobs that match your search criteria.</p>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>

        
        <div class="bg-white rounded-lg mx-2 mt-4 pt-4">
            <span class="font-bold text-lg ml-6 text-red-600 mt-4">Overdue & Undispatched Deliveries</span>
            <div #failedTable  class="overflow-y-auto h-64 mt-4 no-scrollbar">
                <table class="table table-fixed w-full text-sm">
                    <!-- <thead class="text-sm text-gray-800 bg-red-100">
                        <tr>
                            <th class="px-4 py-3 text-center">Job No</th>
                            <th class="px-4 py-3 text-center">Job Name</th>
                            <th class="px-4 py-3 text-center">Customer</th>
                            <th class="px-4 py-3 text-center">Status</th>
                        </tr>
                    </thead> -->
                    <tbody @slideIn>
                        @for (jobs of $$failedJobs(); track jobs) {
                        <tr class="border-y sm:text-xs text-gray-900 lg:text-[12px] text-center justify-center">
                                <td class="px-2 py-2 break-words whitespace-normal ">{{ jobs.jobNo }}</td>
                                <td class="pr-2 px-4 py-2 break-words whitespace-normal text-ellipsis text-left">{{ jobs.jobDescription }}</td>
                                <td class="py-2 px-4 break-words whitespace-normal uppercase text-ellipsis text-left">{{ jobs.customer || '-' }}</td>
                                <td class="py-2">
                                    <app-status-badge [jobStatus]="jobs.jobStatus"></app-status-badge>
                                </td>
                                
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="12" class="px-6 py-10">
                                    <div class="flex flex-col items-center justify-center text-center">
                                        <p class="text-xl font-semibold text-gray-700 mb-2">No Jobs Found</p>
                                        <p class="text-gray-500">We couldn't find any jobs that match your search criteria.</p>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<!-- <div class="px-6 mt-4">
  <div  #machineContainer class="flex overflow-x-auto space-x-4 pb-6 no-scrollbar">
    @for (imp of $$Impressions(); track imp) {
        @for (machine of imp.machines; track machine) {
       
      <div class="min-w-[260px] bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-5 flex flex-col">
        
        
        <div class="flex border-b border-gray-200 pb-3">
            <div>
                <h3 class="font-semibold text-lg text-gray-900 truncate">
                    {{ machine.machineName }}
                </h3>
                <div *ngIf="getMachineShift(machine.machineName) as shift" class="mb-1">
                    <p class="text-xs text-gray-500 flex flex-col">
                        <span class="font-bold">{{ shift.shiftDate | date:'MMM d, y' }} - {{ shift.currentShift }} </span>
                        <span></span>
                    </p>
                </div>
                <span class="text-xs font-medium px-2 py-1 rounded-lg"
                    [ngClass]="{
                    'bg-green-200 text-green-700': machine.machineStatus === 'operational',
                    'bg-yellow-200 text-yellow-700': machine.machineStatus === 'idle',
                    'bg-red-200 text-red-700': machine.machineStatus === 'hold',
                    'bg-blue-200 text-blue-700': machine.machineStatus === 'maintenance',
                    'bg-orange-300 text-orange-700': machine.machineStatus === 'make ready'
                    }">
                    {{ machine.machineStatus | uppercase}}
                </span>
            </div>
         
        </div>
        

        <div class="mt-4 space-y-2">
          <div class="flex justify-between text-sm text-gray-600">
            <span>Planned</span>
            <span class="font-semibold text-gray-800">{{ machine.plannedImpression | number }} {{ machine.unitOfMachine }}</span>
          </div>
          <div class="flex justify-between text-sm text-gray-600">
            <span>Actual Output</span>
            <span class="font-semibold text-gray-800">{{ machine.actualImpression | number }} {{ machine.unitOfMachine }}</span>
          </div>
          <div class="flex justify-between text-sm text-gray-600">
            <span>Average Output</span>
            <span class="font-semibold text-gray-800">{{ machine.hourlyOutput | number:'1.0-0' }} {{ machine.unitOfMachine }}</span>
          </div>
        </div>

        <div class="mt-4">
          <div class="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
            <div class="bg-indigo-600 h-2.5 rounded-full transition-all duration-700"
              [style.width.%]="getMachineUtilization(machine)">
            </div>
          </div>
          <p class="text-xs font-medium text-gray-600 mt-2 text-right">
            {{ getMachineUtilization(machine) }}% Utilization
          </p>
        </div>
      </div>
    } @empty {
      <div class="text-gray-500 italic">No machines available</div>
    }}
  </div>
</div> -->